import generateTypes from '../utils/generateTypes';

export const GET_ENGAGEMENT_TOOLS = generateTypes('GET_ENGAGEMENT_TOOLS');
export const RESET_ENGAGEMENT_TOOLS = generateTypes('RESET_ENGAGEMENT_TOOLS');
